import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

import { enterpriseArticleFragment } from '../articles/queries/enterpriseArticleQuery';

export const entWebsiteBlockArticleQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${enterpriseArticleFragment}

  query entWebsiteBlockArticle($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EnterpriseArticle
      }
    }
  }
`;
